import React, { useContext, useEffect, useState } from 'react';
import { RootContext } from '../context';

export const PromptTerminal: React.FC = () => {
  const {
    level,
    prompt,
    setLevel,
    setPerk,
    setPrompt,
    setVocation,
  } = useContext(RootContext);

  const [forceUpdate, setForceUpdate] = useState(1);
  const [slotValues, setSlotValues] = useState<number[]>([]);
    
  useEffect(() => {
    const TOTALSLOTS = 40;
    const originalSlots = [
        2, 8, 9, 18, 19, 20, 28, 29, 34, -1,
        3, 10, 11, 21, 22, 23, 30, 31, 35, -1,
        1, 7, 6, 17, 16, 15, 27, 26, 33, -1,
        0, 5, 4, 14, 13, 12, 25, 24, 32, -1
    ];
    for (var index = 0; index < TOTALSLOTS; index++) {
        if ((index + 1) % 10 == 0) {
            continue;
        }
        setPerk(originalSlots[index], slotValues[index] || 0);
    }
 }, [forceUpdate])

    function onParsePrompt() {
        setForceUpdate(forceUpdate + 1);
        let treated = prompt.replace('!wheel ', '');
        let split = treated.split(':');

        let countRealNumber = 0;
        let completedVocation = false;
        let completedLevel = false;
        split.forEach((value) => {
            if (!completedVocation) {
                completedVocation = true;
                switch (value.toLowerCase()) {
                    case 'druid': {
                        setVocation('druid');
                        break;
                    }
                    case 'paladin': {
                        setVocation('paladin');
                        break;
                    }
                    case 'sorcerer': {
                        setVocation('sorcerer');
                        break;
                    }
                    default:
                        setVocation('knight');
                }
            } else if (!completedLevel) {
                var v = Number(value);
                if (v) {
                    setLevel(v);
                }
                completedLevel = true;
            } else {                
                var v = Number(value);
                if (v) {
                    const tmp_slotValues = slotValues;
                    tmp_slotValues[countRealNumber] = v;
                    setSlotValues(tmp_slotValues);
                }
                countRealNumber++;
            }
        });
        return;
    }

    function onChangePrompt(value : string) {
        setPrompt(value);
    }

    function onCopy() {
        navigator.clipboard.writeText(prompt);
    }

    return (
    <>
        <span style={{padding: '2px'}}>Prompt Code</span>
        <div>
            <button style={{ width: "auto", padding: '4px 6px 4px 6px', marginRight:"5px"}} onClick={onParsePrompt}>Load</button>
            <input style={{width: "80%"}} placeholder="terminal" value={prompt}  onChange={ (e) => onChangePrompt(e.target.value)}/>
            <button style={{ width: "auto", padding: '4px 6px 4px 6px', marginLeft:"5px" }} onClick={ onCopy }>Copy</button>
        </div>
    </>
    )
}